// Prompt AC CAMBIO 1 (2026-09-21): barra de accesos fija (Customer/Project/
// Estimate/Invoice/Jobs), igual en la ficha de trabajo, el permiso y el
// invoice — un acceso sin documento asociado se ve apagado, nunca se oculta.
// El permiso suma "Customer Profile" (showCustomerProfile) por su propio
// mockup. Reusa los mismos patrones de navegacion que ya existian
// (openEstimateId/openInvoiceId/jobs/:id/projects/:id) — no rutas nuevas.
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { User, FolderKanban, FileText, Receipt, Wrench } from 'lucide-react';

const COLOR_CLASSES = {
  slate: 'text-slate-700 bg-slate-50 border-slate-200 hover:bg-slate-100',
  emerald: 'text-emerald-700 bg-emerald-50 border-emerald-200 hover:bg-emerald-100',
  violet: 'text-violet-700 bg-violet-50 border-violet-200 hover:bg-violet-100',
  blue: 'text-[#003366] bg-blue-50 border-blue-200 hover:bg-blue-100',
  amber: 'text-amber-700 bg-amber-50 border-amber-200 hover:bg-amber-100',
};

export default function QuickLinksBar({
  entityType, entityId, relations: relationsProp, customer,
  showCustomerProfile = false, className = '', testId = 'quick-links-bar',
}) {
  const navigate = useNavigate();
  const [relations, setRelations] = useState(relationsProp || null);

  useEffect(() => {
    if (relationsProp) { setRelations(relationsProp); return; }
    if (!entityType || !entityId) { setRelations(null); return; }
    api.get(`/relations/${entityType}/${entityId}`).then(r => setRelations(r.data)).catch(() => setRelations(null));
  }, [entityType, entityId, relationsProp]);

  const project = relations?.project || null;
  const estimate = (relations?.estimates || [])[0] || null;
  const invoice = (relations?.invoices || [])[0] || null;
  const job = (relations?.jobs || [])[0] || null;

  const goContact = () => customer?.id && navigate(`/contacts/${customer.id}`);

  const items = [
    { key: 'customer', icon: User, label: 'Customer', enabled: !!customer?.id, onClick: goContact, color: 'slate' },
    { key: 'project', icon: FolderKanban, label: 'Project', enabled: !!project, onClick: () => project && navigate(`/projects/${project.id}`), color: 'emerald' },
    { key: 'estimate', icon: FileText, label: 'Estimate', enabled: !!estimate, onClick: () => estimate && navigate('/estimates', { state: { openEstimateId: estimate.id } }), color: 'violet' },
    { key: 'invoice', icon: Receipt, label: 'Invoice', enabled: !!invoice, onClick: () => invoice && navigate('/invoices', { state: { openInvoiceId: invoice.id } }), color: 'blue' },
    { key: 'jobs', icon: Wrench, label: 'Jobs', enabled: !!job, onClick: () => job && navigate(`/jobs/${job.id}`), color: 'amber' },
  ];
  if (showCustomerProfile) {
    items.push({ key: 'customer-profile', icon: User, label: 'Customer Profile', enabled: !!customer?.id, onClick: goContact, color: 'slate' });
  }

  return (
    <div data-testid={testId} className={`flex items-center gap-1.5 flex-wrap ${className}`}>
      {items.map(it => (
        <button
          key={it.key}
          type="button"
          disabled={!it.enabled}
          onClick={it.enabled ? it.onClick : undefined}
          data-testid={`${testId}-${it.key}`}
          className={`flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1.5 rounded-lg border transition-colors ${
            it.enabled ? COLOR_CLASSES[it.color] : 'text-gray-300 bg-gray-50 border-gray-100 cursor-not-allowed'
          }`}
        >
          <it.icon className="w-3.5 h-3.5" /> {it.label}
        </button>
      ))}
    </div>
  );
}
